module.exports = __webpack_public_path__ + "static/media/doc-7.6ab8204e.jpg";